import * as tslib_1 from "tslib";
export const attachABRResetLogic = (player) => {
    if (player.buffered.length <= 0)
        return;
    // switch to normal ABR when THEO buffered beyond 10 seconds
    if (player.buffered.end(player.buffered.length - 1) > 10) {
        player.videoTracks[0].targetQuality = null;
        player.removeEventListener('progress', attachABRResetLogic);
    }
};
export const languages = {
    'esp': {
        "Play": "Reproducir",
        "Pause": "Pausa",
        "Current Time": "Tiempo reproducido",
        "Duration Time": "DuraciÃ³n total",
        "Remaining Time": "Tiempo restante",
        "Stream Type": "Tipo de secuencia",
        "LIVE": "DIRECTO",
        "Loaded": "Cargado",
        "Progress": "Progreso",
        "Fullscreen": "Pantalla completa",
        "Exit fullscreen": "Salir de pantalla completa",
        "Mute": "Silenciar",
        "Unmute": "No silenciado",
        "Playback Rate": "Velocidad de reproducciÃ³n",
        "Subtitles": "Subtítulos",
        "subtitles off": "Subtítulos desactivados",
        "Captions": "Subtítulos especiales",
        "captions off": "Subtítulos especiales desactivados",
        "Chapters": "Capítulos",
        "Settings": "Ajustes",
        "Speed": "Velocidad",
        "Language": "Idioma",
        "Subtitle": "Subtítulos",
        "Options": "Opciones",
        "Subtitle options": "Opciones de Subtítulos",
        "Font family": "Tipo de Fuente",
        "Font color": "Color de Fuente",
        "Font opacity": "Opacidad de Fuente",
        "Font size": " Tamaño de Fuente",
        "Background color": "Color de Fondo",
        "Background opacity": "Opacidad del Fondo",
        "Window color": "Color de Ventana",
        "Window opacity": "Opacidad de Ventana",
        "Default": "Predeterminado",
        "default": "Predeterminado",
        "White": "Blanco",
        "Yellow": "Amarillo",
        "Green": "Verde",
        "Cyan": "Cian",
        "Blue": "Azul",
        "Magenta": "Magenta",
        "Red": "Rojo",
        "Black": "Negro",
        "None": "Ninguna",
        "Drop Shadow": "Sombra Paralela",
        "Raised": "Elevada",
        "Depressed": "Deprimida",
        "Uniform": "Uniforme",
        "Start Casting": "Transmitir",
        "Connecting": "Conectando",
        "Stop Casting": "Dejar de Transmitir",
        "Subtitle Options": "Opciones de Subtítulos",
        "Character edge style": "Estilo de borde de personaje",
        "You aborted the media playback": "Ha interrumpido la reproducciÃ³n del vÃ­deo.",
        "A network error caused the media download to fail part-way.": "Un error de red ha interrumpido la descarga del vÃ­deo.",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.": "No se ha podido cargar el vÃ­deo debido a un fallo de red o del servidor o porque el formato es incompatible.",
        "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La reproducciÃ³n de vÃ­deo se ha interrumpido por un problema de corrupciÃ³n de datos o porque el vÃ­deo precisa funciones que su navegador no ofrece.",
        "No compatible source was found for this media.": "No se ha encontrado ninguna fuente compatible con este vÃ­deo."
    }
};
export const getDRM = () => {
    if ((navigator.userAgent.includes("Opera") || navigator.userAgent.includes('OPR')))
        return 'Opera';
    if (navigator.userAgent.includes("MSIE") || navigator.userAgent.includes("Edg") || document['documentMode'])
        return 'pr';
    if (navigator.userAgent.includes("Chrome"))
        return 'wv';
    if (navigator.userAgent.includes("Safari"))
        return 'fps';
    if (navigator.userAgent.includes("Firefox"))
        return 'wv';
    return 'unknown';
};
//# sourceMappingURL=theoPlayer.js.map